export default __webpack_public_path__ + "static/americanexpress-5ebf32286772990cda726fac8b12e710.png";